function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { closeModal, openModal } from "@common/actions";
import { getUserMessages, markMessagesAsRead } from "@common/actions/user-details";
import Button from "@material-ui/core/Button";
import { get, isEmpty } from "lodash";
import { withSnackbar } from "notistack";
import React, { PureComponent, createRef } from "react";
import { connect } from "react-redux";
import CustomScrollbar from "@common/components/CustomScrollbar";
import { SCROLLBAR } from "@common/services/responsive";
var MessageModule = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(MessageModule, PureComponent);
    var _super = _create_super(MessageModule);
    function MessageModule(props) {
        _class_call_check(this, MessageModule);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            messages: [],
            currMessageIndex: 0
        };
        _this.handleConfirm = _this.handleConfirm.bind(_assert_this_initialized(_this));
        _this.filterMessages = _this.filterMessages.bind(_assert_this_initialized(_this));
        _this.contentRef = /*#__PURE__*/ createRef();
        _this.messageIntervalId = null;
        return _this;
    }
    _create_class(MessageModule, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var getMessages;
                    return _ts_generator(this, function(_state) {
                        getMessages = function() {
                            var _ref = _async_to_generator(function() {
                                var messages, filtered;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this.props.getUserMessages()
                                            ];
                                        case 1:
                                            messages = _state.sent();
                                            filtered = _this.filterMessages(messages);
                                            _this.setState({
                                                messages: _to_consumable_array(filtered)
                                            });
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function getMessages() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        getMessages();
                        _this.messageIntervalId = setInterval(getMessages, 1000 * 60 * 60);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.messageIntervalId) clearInterval(this.messageIntervalId);
            }
        },
        {
            key: "filterMessages",
            value: function filterMessages(unfiltered) {
                return unfiltered.filter(function(mes) {
                    return (mes === null || mes === void 0 ? void 0 : mes.read) === false && (mes === null || mes === void 0 ? void 0 : mes.priority) !== "normal";
                });
            }
        },
        {
            key: "handleConfirm",
            value: function handleConfirm() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_contentRef, messages, mes, data, res, _this_contentRef_current;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                messages = _this.state.messages;
                                mes = messages.pop();
                                data = JSON.stringify({
                                    ids: [
                                        mes.id
                                    ]
                                });
                                return [
                                    4,
                                    _this.props.markMessagesAsRead(data)
                                ];
                            case 1:
                                res = _state.sent();
                                _this.props.getUserMessages();
                                _this.setState({
                                    messages: _to_consumable_array(messages)
                                });
                                if ((_this_contentRef = _this.contentRef) === null || _this_contentRef === void 0 ? void 0 : _this_contentRef.current) {
                                    ;
                                    (_this_contentRef_current = _this.contentRef.current) === null || _this_contentRef_current === void 0 ? void 0 : _this_contentRef_current.scrollIntoView({
                                        behavior: "instant",
                                        block: "start"
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "closeModal",
            value: function closeModal() {
                this.props.setPostLoginModalOpened(false);
                this.props.closeModal();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this_state_messages;
                if (((_this_state_messages = this.state.messages) === null || _this_state_messages === void 0 ? void 0 : _this_state_messages.length) === 0) {
                    this.closeModal();
                    this.props.getUserMessages();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var messages = this.state.messages;
                if (!messages) return null;
                var i18n = this.props.i18n;
                var currMessage = messages[messages.length - 1];
                if (!currMessage) return null;
                var date = new Date(currMessage.timestamp * 1000);
                var pad = function(number) {
                    return number < 10 ? "0".concat(number) : number;
                };
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var truncTitle = (currMessage === null || currMessage === void 0 ? void 0 : currMessage.title.length) > 120 ? "".concat(currMessage === null || currMessage === void 0 ? void 0 : currMessage.title.slice(0, 120), "...") : currMessage === null || currMessage === void 0 ? void 0 : currMessage.title;
                var truncSender = (currMessage === null || currMessage === void 0 ? void 0 : currMessage.from.length) > 90 ? "".concat(currMessage === null || currMessage === void 0 ? void 0 : currMessage.from.slice(0, 90), "...") : currMessage === null || currMessage === void 0 ? void 0 : currMessage.from;
                var content = /*#__PURE__*/ _jsxs("div", {
                    className: "content-holder",
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            className: "display-image",
                            src: isEmpty(currMessage === null || currMessage === void 0 ? void 0 : currMessage.media) ? "common/assets/media/default_message.jpg" : currMessage === null || currMessage === void 0 ? void 0 : currMessage.media,
                            alt: "",
                            ref: this.contentRef
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "message-content",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "message-title",
                                    title: currMessage === null || currMessage === void 0 ? void 0 : currMessage.title,
                                    children: truncTitle
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "message-subtitle",
                                    children: "".concat(date.getDate(), " ").concat(i18n.months[date.getMonth()], " \xb7 ").concat(pad(hours), ":").concat(pad(minutes), " \xb7 ").concat(truncSender)
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "message-text",
                                    children: currMessage === null || currMessage === void 0 ? void 0 : currMessage.content
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "message-footer",
                            children: /*#__PURE__*/ _jsx(Button, {
                                classes: {
                                    label: "ux-button-label"
                                },
                                className: "button raised half-width pointer confirm-button",
                                onClick: this.handleConfirm,
                                children: "Затвори"
                            })
                        })
                    ]
                });
                return /*#__PURE__*/ _jsx("div", {
                    className: "modal-overlay message-modal-overlay",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "modal message-wrapper-modal",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "paper-card-message",
                            children: this.props.screenType.web ? /*#__PURE__*/ _jsx(CustomScrollbar, {
                                className: "message-scrollbar",
                                thumbSize: SCROLLBAR.FAQ.thumbSize,
                                children: content
                            }) : content
                        })
                    })
                });
            }
        }
    ]);
    return MessageModule;
}(PureComponent);
var mapStateToProps = function(param) {
    var i18n = param.i18n, userDetails = param.userDetails;
    return {
        i18n: i18n,
        userDetails: userDetails
    };
};
export default withSnackbar(connect(mapStateToProps, {
    openModal: openModal,
    closeModal: closeModal,
    markMessagesAsRead: markMessagesAsRead,
    getUserMessages: getUserMessages
})(MessageModule));
